import {
	QueryClientProvider as ReactQueryClientProvider,
} from '@tanstack/react-query'
import type {
	JSX,
	ReactNode,
} from 'react'

import {
	queryClientConfig,
} from '../../config'

export const QueryClientProvider = ({
	children,
}: {
	children: ReactNode
}): JSX.Element => {
	return (
		<ReactQueryClientProvider client={queryClientConfig}>
			{children}
		</ReactQueryClientProvider>
	)
}
